import React, { useRef } from "react";
import Transition from "react-transition-group/Transition";
import { LabeledIndicator } from "../indicator/LabeledIndicator";

interface IProps {
  text: string;
  isLoading: boolean;
}

const enterDuration = 0;
const exitDuration = 400;
const exitDelayDuration = 400;

export const SearchLabeledIndicator: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { text, isLoading } = props;

  const nodeRef = useRef(null);

  return (
    <Transition
      in={isLoading}
      timeout={{
        enter: enterDuration,
        exit: exitDuration + exitDelayDuration,
      }}
      unmountOnExit={true}
      nodeRef={nodeRef}
    >
      {(state: any): JSX.Element => (
        <div
          ref={nodeRef}
          style={{
            ...defaultBlockStyle,
            ...transitionBlockStyles[state],
          }}
        >
          <LabeledIndicator text={text} isLoading={true} />
        </div>
      )}
    </Transition>
  );
};

export const defaultBlockStyle: any = {
  transition: `all ${enterDuration}ms ease`,
  opacity: 0,
};

export const transitionBlockStyles: any = {
  entering: {
    opacity: 1,
  },
  entered: {
    opacity: 1,
  },
  exiting: {
    opacity: 0,
    transition: `opacity ${exitDuration}ms ${exitDelayDuration}ms ease`,
  },
  exited: {
    opacity: 0,
    display: "none",
  },
};
